import { createContext, ReactNode } from "react";

export interface GameSound {
  playSound: Function;
}
export const soundFileURL = {
  MISS: "/assets/sounds/miss_hit.mp3",
  SINGLE: "/assets/sounds/single_hit.mp3",
  DOUBLE: "/assets/sounds/double_hit.mp3",
  TRIPLE: "/assets/sounds/triple_hit.mp3",
  GAME_OVER: "/assets/sounds/game_over.mp3",
};

export enum SOUNDS {
  SINGLE = "singleSound",
  DOUBLE = "doubleSound",
  TRIPLE = "tripleSound",
  MISS = "missSound",
  GAME_OVER = "gameOverSound",
}

export const GameSoundContext = createContext<GameSound>({
  playSound: () => {},
});

interface Props {
  children?: ReactNode;
}

export default function GameSoundProvider({ children }: Props) {
  const singleSound = soundFileURL.SINGLE;
  const doubleSound = soundFileURL.DOUBLE;
  const tripleSound = soundFileURL.TRIPLE;
  const missSound = soundFileURL.MISS;
  const gameOverSound = soundFileURL.GAME_OVER;

  function playSound(sound: SOUNDS | number) {
    let id: SOUNDS;
    if (typeof sound === "number") {
      id =
        sound === 1
          ? SOUNDS.SINGLE
          : sound === 2
          ? SOUNDS.DOUBLE
          : SOUNDS.TRIPLE;
    } else {
      id = sound;
    }
    var x: HTMLAudioElement | null = document.getElementById(
      id
    ) as HTMLAudioElement;
    if (!x) return;
    x.currentTime = 0;
    x.play();
  }

  return (
    <GameSoundContext.Provider
      value={{
        playSound,
      }}
    >
      <div style={{ position: "absolute", display: "none" }}>
        <audio preload={"auto"} id={SOUNDS.SINGLE} src={singleSound} />
        <audio preload={"auto"} id={SOUNDS.DOUBLE} src={doubleSound} />
        <audio preload={"auto"} id={SOUNDS.TRIPLE} src={tripleSound} />
        <audio preload={"auto"} id={SOUNDS.MISS} src={missSound} />
        <audio preload={"auto"} id={SOUNDS.GAME_OVER} src={gameOverSound} />
      </div>
      {children}
    </GameSoundContext.Provider>
  );
}
